import { Text } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";

import TimelineLogs, { TimelineLog} from "components/TimelineLogs";

interface HistoricoProps {
  logs:  TimelineLog[];
}

function Historico({ logs }: HistoricoProps) {
  return (
    <Flex flexDir="column">
      <Text fontSize={20} mb={1}>
        Histórico
      </Text>
      {logs.map((log, index) => (
        <TimelineLogs
          data={log}
          key={index}
        />
      ))}
    </Flex>
  );
}

export default Historico;
